"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoostIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.BoostIcon = (0, react_1.forwardRef)(function BoostIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", 
            // eslint-disable-next-line max-len
            d: "M20.1838 13.3381C20.1838 14.4053 19.9896 15.4253 19.6389 16.3661C19.3774 17.0674 19.5859 17.8905 20.2286 18.274C20.8968 18.6727 21.7706 18.4433 22.065 17.7231C22.6162 16.3746 22.9243 14.895 22.9243 13.3381C22.9243 12.2626 22.7695 11.2253 22.4996 10.2391C21.6294 11.0071 20.8415 11.7085 20.1235 12.349C20.1591 12.6735 20.1838 13.0037 20.1838 13.3381ZM11.9622 2.00195C5.90831 2.00195 1 7.07772 1 13.3381C1 14.895 1.30814 16.3746 1.85933 17.7231C2.15374 18.4433 3.02753 18.6727 3.69569 18.274C4.33843 17.8905 4.54692 17.0674 4.28547 16.3661C3.93477 15.4253 3.74054 14.4053 3.74054 13.3381C3.74054 8.6492 7.42794 4.836 11.9622 4.836C14.5027 4.836 16.7609 6.04613 18.2695 7.9251C13.9395 9.48949 11.5593 10.3057 10.5919 10.8838C9.28055 11.666 8.83247 13.3991 9.58886 14.7551C10.3452 16.1112 12.0211 16.5746 13.3324 15.7924C14.6438 15.0102 17.6145 12.1252 24 6.55909L23.6574 5.94694C22.7106 6.29978 21.824 6.62853 20.9895 6.93319C19.015 3.95886 15.7153 2.00195 11.9622 2.00195Z", fill: "currentColor" })));
});
